import { styled } from '@mui/material/styles';

import { Button } from '@mui/material';

const variantStyles = ({ theme, variant, $buttonIcon }) =>
  variant === 'contained'
    ? `
    background-color: ${theme.DS_palette.buttons.enabled} !important;
    color: ${theme.DS_palette.primary.white} !important;

    :active,
    :focus {
      background-color: ${theme.DS_palette.buttons.pressed} !important;
      color: ${theme.DS_palette.primary.white} !important;
    }
    
    &.Mui-disabled {
      background-color: ${theme.DS_palette.buttons.disabled} !important;
      color: ${theme.DS_palette.primary.white} !important;
        span > div {
        svg {
             stroke: ${theme.DS_palette.primary.white};
       }
      }
      
    }

    :hover {
      background-color: ${theme.DS_palette.buttons.hover} !important;
      color: ${theme.DS_palette.primary.white} !important;
    }
  `
    : variant === 'outlined'
    ? `
    background-color:${theme.DS_palette.primary.white};
    color: ${theme.DS_palette.buttons.enabled};
    border: ${theme.DS_border.width.button} solid ${theme.DS_palette.buttons.enabled};
    
    :active,
    :focus {
      border: ${theme.DS_border.width.button} solid ${theme.DS_palette.buttons.pressed};
      color: ${theme.DS_palette.buttons.pressed};
    }
     
    &.Mui-disabled {
      border: ${theme.DS_border.width.button} solid ${theme.DS_palette.buttons.disabled};
      color: ${theme.DS_palette.buttons.disabled};
        span > div {
          svg {
             stroke: ${theme.DS_palette.buttons.disabled};
       }
      }
    }

    :hover {
      background-color: ${theme.DS_palette.buttons.text.hover};
      border: ${theme.DS_border.width.button} solid ${theme.DS_palette.buttons.enabled};
      color: ${theme.DS_palette.buttons.enabled};
    }
`
    : variant === 'text'
    ? `
    background-color: transparent;
    padding: 12px 4px 12px 4px;
    color: ${theme.DS_palette.buttons.enabled};
    
   
    
    :active,
    :focus {
    background-color: transparent;
    text-decoration: underline;
      color:  ${theme.DS_palette.buttons.enabled};
    }
     
    &.Mui-disabled {
      background-color: transparent;
      color: ${theme.DS_palette.buttons.disabled};
       span > div {
       background-color: ${$buttonIcon === 'Contained Icon' ? `${theme.DS_palette.buttons.disabled}` : `transparent`};
       
      }
    }

    :hover {
      text-decoration: underline;
      background-color:  ${
        $buttonIcon === 'Contained Icon' || $buttonIcon === 'Outlined Icon'
          ? `transparent`
          : `${theme.DS_palette.buttons.text.hover}`
      };
      color: ${theme.DS_palette.buttons.enabled};
    }
`
    : null;

const sizeStyles = ({ theme, $isSizeBig, variant }) =>
  $isSizeBig
    ? `
     padding: ${theme.DS_spacing(['xs'])};
     min-height: 56px;
     min-width: ${variant === 'text' ? `auto` : `327px`};
     
  
     ${theme.breakpoints.up('md')} {
      min-height: 68px;
      min-width: ${variant === 'text' ? `auto` : `400px`};
      padding: ${theme.DS_spacing(['sm'])} ${theme.DS_spacing(['xl'])};
     }
`
    : `
     padding: 10px ${theme.DS_spacing(['xs'])};
     min-height: 44px;
     min-width: ${variant === 'text' ? `auto` : `164px`};
  
     ${theme.breakpoints.up('lg')} {
      min-height: 52px;
      min-width: ${variant === 'text' ? `auto` : `200px`};
      padding: 12px ${theme.DS_spacing(['xs'])};
     } 
`;

const StyledButton = styled(Button)(
  ({ theme, variant, $isSizeBig, $buttonIcon }) => `
     z-index: 2;
     text-transform: unset;
     text-align: center;
     border-radius: ${theme.DS_border.radius.button};
     
    :hover {
      box-shadow: ${
        $buttonIcon === 'Contained Icon' || $buttonIcon === 'Outlined Icon'
          ? `none`
          : `${theme.DS_shadows.buttonsHover} `
      };
      cursor: pointer;
    }

     &.Mui-disabled:hover {
      cursor: not-allowed;
     }


     ${sizeStyles({ theme, $isSizeBig, variant })};
     ${variantStyles({ theme, variant, $buttonIcon })};

`,
);

const StyledButtonContent = styled('span')(
  ({ theme, isRight, $buttonIcon, variant }) => `
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    order: ${isRight ? 1 : 2};
    margin-bottom: 3px;
  }

  div{
   order: ${isRight ? 2 : 1};
   transform: ${isRight ? `none` : `rotate(180deg)`};
   padding: 1px;
   margin: ${theme.DS_spacing(['sm'])} 0.75rem;

   border-radius: 100%;
   height: 32px;
   width: 32px;
   aspect-ratio: 1/1;
   background-color: ${$buttonIcon === 'Contained Icon' ? `${theme.DS_palette.buttons.enabled}` : `none`};
   text-align: center;

   svg {
     width: 24px;
    fill: none;
     path {
        stroke: ${
          $buttonIcon === 'Contained Icon' || variant === 'contained'
            ? `${theme.DS_palette.primary.white}`
            : `${theme.DS_palette.buttons.enabled}`
        };
     
     }
   
      height: 100%;
     }
   }
   
  ${theme.breakpoints.up('lg')} {
    span {
      margin-bottom: 2px;
    }
  }
`,
);

export { StyledButton, StyledButtonContent };
